var map = {
	"./icon-contacts.png": 4653,
	"./icon-dress.png": 3407,
	"./icon-foto-e-video.png": 917,
	"./icon-home.png": 3079,
	"./icon-info.png": 5143,
	"./icon-plane.png": 5723,
	"./icon-program.png": 6041,
	"./logo-edenred.png": 6168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;